import { render, staticRenderFns } from "./RegistrarProductoVenta.vue?vue&type=template&id=7a73ff1c&scoped=true&"
import script from "./RegistrarProductoVenta.vue?vue&type=script&lang=js&"
export * from "./RegistrarProductoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a73ff1c",
  null
  
)

export default component.exports